import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToolCard } from "./ToolCard";
import { Button } from "views/components/ui/Button";
import { fetchTools } from "actions/tool";
import { Loader2 } from "lucide-react";

const INITIAL_LIMIT = 40;
const LOAD_MORE_INCREMENT = 20;

const ToolGrid = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [currentOffset, setCurrentOffset] = useState(0);

    useEffect(() => {
        loadInitialTools();
    }, []);

    const loadInitialTools = async () => {
        setIsLoading(true);
        await props.fetchTools(INITIAL_LIMIT, 0);
        setCurrentOffset(INITIAL_LIMIT);
        setIsLoading(false);
    };

    const handleLoadMore = async () => {
        if (!props.hasMore || isLoadingMore) return;

        setIsLoadingMore(true);
        await props.fetchTools(LOAD_MORE_INCREMENT, currentOffset);
        setCurrentOffset((prevOffset) => prevOffset + LOAD_MORE_INCREMENT);
        setIsLoadingMore(false);
    };

    if (isLoading) {
        return (
            <div className="container py-12 px-4 sm:px-6 lg:px-8">
                <div className="flex justify-center items-center min-h-[50vh]">
                    <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
                </div>
            </div>
        );
    }

    // Ensure tools is an array before mapping
    const tools = Array.isArray(props.tools) ? props.tools : [];

    return (
        <div className="container py-12 px-4 sm:px-6 lg:px-8 bg-white dark:bg-gray-800">
            <h2 className="text-2xl font-bold tracking-tight mb-8">
                Just Landed
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {tools.map((tool) => (
                    <ToolCard
                        key={tool.id}
                        id={tool.id}
                        image={tool.image}
                        title={tool.title}
                        description={tool.description}
                        url={tool.url}
                        loves={tool.loves}
                        tags={tool.tags}
                    />
                ))}
            </div>
            <div className="mt-12 flex flex-col items-center gap-4">
                {props.hasMore && (
                    <Button
                        variant="outline"
                        size="lg"
                        onClick={handleLoadMore}
                        disabled={!props.hasMore || isLoadingMore}
                    >
                        {isLoadingMore ? (
                            <>
                                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                Loading...
                            </>
                        ) : (
                            "Load More"
                        )}
                    </Button>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    tools: state.tool.tools || [],
    hasMore: state.tool.hasMore,
    totalCount: state.tool.totalCount,
});

export default connect(mapStateToProps, { fetchTools })(ToolGrid);
